import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-status-bar-renderer-component",
  templateUrl: "./status-bar-renderer.component.html",
  styleUrls: ["./status-bar-renderer.component.scss"],
})
export class StatusBarRendererComponent implements OnDestroy {
  private params: any;
 private destroy$ = new Subject<void>();
  constructor() {}

  agInit(params: any): void {
    this.params = params;
  }

  getCount(): number {
    const detailRows = [];
    this.params.api.forEachNode((node) => {
      if (node.expanded) { detailRows.push(node.data) }
    });
    let totalCount = this.params.api.getDisplayedRowCount();
    totalCount = totalCount - detailRows.length;
    return this.params.model ? totalCount - 1 : totalCount;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
